export default __webpack_public_path__ + "static/media/stormy.d2899756.png";